var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchool = function SvgSchool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.464 7.173a1.25 1.25 0 0 0-.928 0L2.869 13.84a1.25 1.25 0 0 0 0 2.32l5.881 2.353v8.153c0 2.04 1.59 3.639 3.62 4.654 2.089 1.044 4.834 1.596 7.63 1.596s5.541-.552 7.63-1.596c2.03-1.015 3.62-2.614 3.62-4.654v-8.153l4.167-1.667V25a1.25 1.25 0 0 0 2.5 0V15c0-.511-.312-.97-.786-1.16zm9.109 9.318-.073.03-9.5 3.8-9.5-3.8-.073-.03-3.728-1.49L20 9.68 33.3 15zM11.25 19.513l8.286 3.314c.298.12.63.12.928 0l8.286-3.314v7.153c0 .613-.517 1.558-2.238 2.418-1.662.831-4.004 1.332-6.512 1.332s-4.85-.501-6.512-1.332c-1.72-.86-2.238-1.805-2.238-2.418z",
    clipRule: "evenodd"
  })));
};
export default SvgSchool;